import { api } from '../lib/api'

export interface WatchlistEntry {
  symbol:     string
  notes:      string | null
  sort_order: number
  added_at:   string
}

export const watchlistApi = {
  list:   () => api.get<WatchlistEntry[]>('/watchlist').then((r) => r.data),

  add: (symbol: string, sort_order = 0) =>
    api.post<WatchlistEntry>('/watchlist', { symbol, sort_order }).then((r) => r.data),

  remove: (symbol: string) => api.delete(`/watchlist/${symbol}`),

  reorder: (items: { symbol: string; sort_order: number }[]) =>
    api.put('/watchlist/reorder', items).then((r) => r.data),
}
